import {
    BLOCK_SELECTOR as BLOCK,
    HEADER_MODULE_SELECTOR as HEADER_MODULE,
} from './registry.js';

export const INSPECT_ACCENT_RGB = '147, 51, 234';
export const INSPECT_ACCENT_STRONG = 'rgb(126, 34, 206)';
export const INSPECT_ATTACH = 'rgb(16, 185, 129)';
export const INSPECT_OFFSET = Object.freeze({ tight: 0, token: 3, module: 6 });
/** Class on `document.body` while Appearance Inspect is on. */
export const INSPECT_CLASS = 'theme-inspect-active';

export function accent(alpha) {
    return `rgba(${INSPECT_ACCENT_RGB}, ${alpha})`;
}

/** Quote-safe value for [attr="..."] selectors. Ids are generated alphanumerics. */
export function attrValue(value) {
    return String(value).replace(/["\\]/g, '\\$&');
}

/** Interaction rules only; the overlay draws every frame and handle. */
export function buildInspectStylesheet({ inspectClass }) {
    return `
            html {
                overscroll-behavior: none;
            }
            .${inspectClass} [data-theme-path],
            .${inspectClass} [data-page-path],
            .${inspectClass} [data-header-module] {
                cursor: crosshair;
            }
            .${inspectClass} ${BLOCK} [data-page-path="page.grid"],
            .${inspectClass} ${BLOCK} [data-page-path="page.content"] {
                cursor: inherit;
            }
            html[data-edit-group="header"] .${inspectClass} ${HEADER_MODULE},
            html[data-edit-group="viewer"] .${inspectClass} [data-header-module^="icon-"],
            html[data-edit-group="viewer"] .${inspectClass} [data-header-module="viewer-logo"],
            html[data-edit-group="viewer"] .${inspectClass} [data-header-module="media-title"],
            html[data-edit-group="video"] .${inspectClass} [data-header-module^="video-"] {
                cursor: move;
                pointer-events: auto;
            }
            html[data-edit-group="header"] .${inspectClass} ${HEADER_MODULE} a {
                pointer-events: none;
            }
            [data-header-module][data-attach-target="1"] {
                outline: 2px solid ${INSPECT_ATTACH} !important;
                outline-offset: 2px !important;
            }
            .${inspectClass} a { pointer-events: none; }
            .${inspectClass} [data-theme-path],
            .${inspectClass} [data-page-path],
            .${inspectClass} [data-header-module] { pointer-events: auto; }
            .${inspectClass} [data-action-button],
            .${inspectClass} [data-action-button] * {
                pointer-events: auto !important;
                cursor: pointer;
            }
        `;
}
